<template>
  <div class="seckill-order">
    <div class="order-list" v-if="orderList.length">
      <list :finished="finished" @load="onLoad" finished-text="没有更多了" v-model="loading">
        <div class="order-item"
          v-for="(order, index) in orderList" :key="index"
          @click="viewOrderDetail(order)"
        >
        <div class="order-title">
          <div class="store">
            <div class="store-icon">
              <img :src="order.shop_img" />
            </div>
            <div class="store-name van-ellipsis">{{ order.shop_title }}</div>
          </div>
          <div
            class="status"
            :class="{ pedding: order.status == 1 || order.status == 5 }"
          >
            {{ order.status_title }}
          </div>
        </div>
        <div class="order-desc">
          <div class="goods-detail">
            <div class="goods-img">
              <img :src="order.coupon_img" />
            </div>
            <div class="goods-intro">
              <div class="name van-ellipsis">{{ order.coupon_title }}</div>
              <div class="time">有效期：{{ order.coupon_end_at }}</div>
            </div>
          </div>
        </div>
        <div class="order-intro">
          <div class="order-time">{{ order.created_at }}</div>
          <div class="intro">共 1 件商品，实付：{{ order.money }}</div>
        </div>
        </div>
      </list>
    </div>
    <div class="empty" v-show="empty && !orderList.length">
      <no-data />
    </div>
  </div>
</template>

<script>
import { List } from 'vant'
import NoData from './OnData'
let flag = false
export default {
  components: {
    NoData,
    List
  },
  data () {
    return {
      orderList: [],
      empty: false,
      pageNum: 1,
      loading: false,
      finished: false
    }
  },
  created () {
    this.getOrderList()
  },

  methods: {
    onLoad () {
      if (flag) {
        return
      }
      flag = true
      setTimeout(() => {
        this.getOrderList(++this.pageNum).then(() => {
          this.loading = false
          flag = false
        })
      }, 1000)
    },
    async getOrderList (pageNum) {
      const res = await this.$axios.get(`api/order/hymall_list/${pageNum || 1}/10`)
      if (res.status === 200) {
        const { code, data, msg } = res.data
        if (code === 0) {
          this.phoneCode = data.phone
          this.orderList = [...this.orderList, ...data.list]
        } else if (code === 906) {
          if (this.pageNum === 1) {
            this.empty = true
          }
          this.finished = true
        } else {
          this.$toast(msg)
        }
      }
    },
    viewOrderDetail (order) {
      let url = 'https://hymall.wanyuenet.com/appletLoding?appletUrl=pagesMall%2Flogin%2FauthLogin'
      let ap = 'baogang'
      let ch = process.env.VUE_APP_CURRENTMODE === 'prod' ? 'su2l829313220091' : 'su2e054872509710'
      let rq = `/pagesMall/orderDetail/orderDetail?type=shop_coupon&oid=${order.id}`
      let tk = this.phoneCode
      // console.log(`ap=${ap}&rq=${encodeURIComponent(rq)}&ch=${ch}&tk=${tk}`)
      location.href = `${url}&ap=${ap}&ch=${ch}&rq=${encodeURIComponent(rq)}&tk=${tk}`
    }
  }
}
</script>

<style lang="less" scoped>
.order-list{
  background: #F5F5F5;
  min-height: 100vh;
  padding-top: .2rem;
}
.order-item {
  padding: 0 .3rem .3rem;
  background-color: #fff;
  margin-bottom: .2rem;
  .order-title {
    .flex-between;
    padding: .21rem 0;
    font-size: .26rem;
    color: #222;
    border-bottom: 1px solid #EAEAEA;
    .store{
      display: flex;
      align-items: center;
    }
    .store-icon {
      width: .36rem;
      height: .36rem;
      margin-right: .1rem;
    }
    .status {
      font-size: .24rem;
      color: #747474;
    }
    .pedding {
      color: #ff9600;
    }
  }
  .goods-detail {
    display: flex;
    align-items: center;
    .goods-img {
      width: 1rem;
      height: 1rem;
      margin-right: .26rem;
    }
    .goods-intro {
      max-width: 5.6rem;
      height: .9rem;
      .flex-column;
      justify-content: space-between;
      .name {
        font-size: .28rem;
        color: #404040;
        font-weight: bold;
      }
      .time {
        font-size: .24rem;
      }
    }
  }
  .order-desc{
    padding: .2rem 0;
  }
  .order-intro {
    color: #4f4f4f;
    font-size: .26rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .order-time {
      color: #9c9c9c;
      font-size: .22rem;
    }
  }
}
</style>
